import type React from "react";
import {Alert} from "@mui/material";
import type {SupplierExtLink} from "~/pages/supplier-360/types/Supplier360PdlTypes";

const REASON: Record<string, string> = {country_mismatch: 'the matched headquarters is outside every country in your spend'};

/**
 * Staff-only notice: a candidate match awaiting review, or a match kept but flagged. Enforced
 * server-side, not just by this component — `SupplierExtLinkViewSet` excludes `candidate`/`rejected`
 * rows and blanks `review_reason` for anyone outside the `mithra_staff` auth group (not Django's
 * built-in `User.is_staff`, which this codebase doesn't use for authorization), so a customer user's
 * `link` never carries either in the first place.
 */
export const MatchReviewBanner: React.FC<{link: SupplierExtLink | undefined}> = ({link}) => {
    if (!link) return null;
    if (link.status === 'candidate') {
        return (
            <Alert severity="warning" variant="outlined" sx={{py: 0}}>
                {`Company data match needs review · likelihood ${link.likelihood ?? '?'}/10 · not shown to customers`}
            </Alert>
        );
    }
    if (link.review_reason) {
        const text = link.review_reason.split(',').map(r => REASON[r] ?? r).join('; ');
        return <Alert severity="info" variant="outlined" sx={{py: 0}}>{`Company data match flagged for review: ${text}`}</Alert>;
    }
    return null;
};
